@if (hasDiscount() || isEditing()) {
  <span class="absolute top-0 left-8 z-10 flex items-center gap-1.5 whitespace-nowrap -translate-y-1/2">
    @if (hasDiscount()) {
      <p-tag
        [value]="discountBadgeLabel()"
        size="small"
        severity="success"
        styleClass="shadow-sm !rounded-full !bg-emerald-100 !text-emerald-700 !border-[0.5px] !border-emerald-700 !text-body-2xs-700"
      />
    }
    @if (isEditing()) {
      <p-tag
        value="Editing"
        icon="pi pi-pencil"
        size="small"
        severity="contrast"
        [rounded]="false"
        styleClass="option-editing-tag shadow-sm"
      />
    }
  </span>
}
<div class="flex gap-1.5 lg:gap-2.5 grow shrink basis-full lg:basis-0 min-w-0 cursor-pointer">
  @if (!isReadonly() && !isKitLinkedProduct() && (canCancel() || canDelete())) {
    <p-button
      class="order-last ml-auto self-start shrink-0 lg:hidden"
      icon="pi pi-ellipsis-v"
      [text]="true"
      [rounded]="true"
      severity="secondary"
      (onClick)="$event.stopPropagation(); openActionMenu($event)"
    />
  }
  <div
    class="relative bg-surface-100 rounded-2xl w-12 h-12 lg:w-18 lg:h-18 shrink-0 overflow-hidden shadow-module"
    (click)="$event.stopPropagation()"
  >
    @if (showFloorPlanAddedBadge()) {
      <div class="flex flex-col w-full h-full bg-sky-100">
        <span
          class="flex-1 flex items-center justify-center pt-[1px] pr-[4px] pb-0 pl-[4px] lg:pt-[14px] lg:pr-[11.5px] lg:pb-[6px] lg:pl-[11.5px] text-body-2xs-600 lg:text-sm lg:font-bold font-bold text-sky-800 uppercase tracking-wide text-center leading-tight lg:leading-4"
          >Floor Plan</span
        >
        <span
          class="flex items-center justify-center bg-sky-700 text-white text-body-2xs-600 lg:text-xs lg:font-bold text-center uppercase tracking-wide leading-none py-1"
          >Added</span
        >
      </div>
    } @else if (showFloorPlanActiveBadge()) {
      <div class="flex flex-col w-full h-full bg-green-100">
        <span
          class="flex-1 flex items-center justify-center pt-[1px] pr-[4px] pb-0 pl-[4px] lg:pt-[14px] lg:pr-[11.5px] lg:pb-[6px] lg:pl-[11.5px] text-body-2xs-600 lg:text-sm lg:font-bold font-bold text-green-700 uppercase tracking-wide text-center leading-tight lg:leading-4"
          >Floor Plan</span
        >
        <span
          class="flex items-center justify-center bg-green-700 text-green-100 text-body-2xs-600 lg:text-xs lg:font-bold text-center uppercase tracking-wide leading-none py-1"
          >Active</span
        >
      </div>
    } @else if (productPreviewImages().length) {
      <lib-image-preview
        [images]="productPreviewImages()"
        [title]="productOptionName()"
        [subheadingTemplate]="productPreviewSubheading"
      >
        <ng-template #productPreviewSubheading>
          <div class="flex flex-wrap gap-x-4 gap-y-0.5 text-body-sm text-surface-500">
            @if (product().categoryName) {
              <span
                >Category: <span class="text-surface-700">{{ product().categoryName }}</span></span
              >
            }
            @if (product().subcategoryName) {
              <span
                >Subcategory: <span class="text-surface-700">{{ product().subcategoryName }}</span></span
              >
            }
          </div>
        </ng-template>
        <img [src]="productImageUrl()" alt="Option image" class="w-full h-full object-cover" />
      </lib-image-preview>
    } @else {
      <img [src]="productImageUrl()" alt="Option image" class="w-full h-full object-cover" />
    }
  </div>
  <div class="flex flex-col items-start justify-between w-full min-w-0">
    <div class="flex sm:items-center items-start flex-col sm:flex-row sm:flex-wrap gap-1 lg:gap-2 mb-1.5 lg:mb-1">
      <h5
        class="text-body-700 text-surface-700 m-0"
        [class.!text-surface-500]="product().isCancelled"
        [class.line-through]="product().isCancelled"
      >
        {{ productOptionTitle() }}
      </h5>
      <div class="flex flex-wrap gap-2">
        @if (product().productClassName) {
          <p-tag
            [value]="product().productClassName ?? undefined"
            size="small"
            severity="info"
            styleClass="!font-bold"
          />
        }
        @if (product().productTypeName) {
          <p-tag
            [value]="product().productTypeName ?? undefined"
            size="small"
            severity="info"
            styleClass="!font-bold"
          />
        }
        @if (product().isCancelled) {
          <p-tag value="Cancelled" size="small" severity="danger" />
        }
        @if (isMismatchedLocation()) {
          <p-tag value="Mismatch Locations" size="small" severity="danger" />
        }
        @if (isLocked()) {
          <p-tag value="Locked" size="small" severity="secondary" icon="pi pi-lock" />
        }
      </div>
    </div>
    @if (categoryLine()) {
      <p class="mb-0 text-surface-500 text-body-xs lg:text-body-sm">{{ categoryLine() }}</p>
    }
    <div class="flex flex-wrap items-center gap-x-4 gap-y-1 text-body-xs text-surface-500 mt-2">
      @if (product().lineNumber) {
        <span
          >Line: <span class="text-body-xs-700">{{ product().lineNumber }}</span></span
        >
      }
      @if (locationLabel()) {
        <span class="inline-flex items-center gap-1">
          <i class="pi pi-map-marker text-body-2xs text-amber-600"></i>
          <span class="text-body-xs-700">{{ locationLabel() }}</span>
        </span>
      }
      @if (attributeSummary()) {
        <span>{{ attributeSummary() }}</span>
      }
    </div>
  </div>
</div>

<div
  class="hidden lg:grid grid-cols-3 items-center gap-x-6 gap-y-2 shrink-0 self-center ml-auto pl-2"
  (click)="$event.stopPropagation()"
>
  <span class="text-body-xs text-surface-500 uppercase tracking-wide leading-none text-center">Quantity</span>
  <span class="text-body-xs text-surface-500 uppercase tracking-wide leading-none text-center">Unit Price</span>
  <span class="text-body-xs text-surface-500 uppercase tracking-wide leading-none text-center">Subtotal</span>

  <div class="justify-self-center whitespace-nowrap">
    @if (canChangeQuantity()) {
      <div class="flex items-center justify-between h-8 gap-1 px-1 rounded-full border border-outline-green">
        <p-button
          icon="pi pi-minus"
          [text]="true"
          [rounded]="true"
          size="small"
          severity="secondary"
          styleClass="!text-outline-green !w-6 !h-6"
          [disabled]="!canDecreaseQuantity()"
          [attr.aria-label]="'Decrease quantity'"
          (onClick)="$event.stopPropagation(); decreaseQuantity()"
        />
        <span class="text-body text-surface-700 leading-none min-w-4 text-center">{{ product().quantity }}</span>
        <p-button
          icon="pi pi-plus"
          [text]="true"
          [rounded]="true"
          size="small"
          severity="secondary"
          styleClass="!text-outline-green !w-6 !h-6"
          [disabled]="!canIncreaseQuantity()"
          [attr.aria-label]="'Increase quantity'"
          (onClick)="$event.stopPropagation(); increaseQuantity()"
        />
      </div>
    } @else {
      <span class="text-body text-surface-700 leading-none">{{ product().quantity }}</span>
    }
  </div>
  <div class="justify-self-center whitespace-nowrap">
    @if (hasDiscount()) {
      <span class="leading-none flex flex-col justify-center">
        <span class="text-body-xs text-surface-500 line-through text-center">{{
          product().unitPrice | currencyFormat
        }}</span>
        <span class="text-body text-emerald-700 ml-1">{{ discountedUnitPrice() | currencyFormat }}</span>
      </span>
    } @else {
      <span class="text-body text-surface-700 leading-none">{{ product().unitPrice | currencyFormat }}</span>
    }
  </div>
  <div class="justify-self-center whitespace-nowrap">
    @if (hasDiscount()) {
      <span class="leading-none flex flex-col justify-center">
        <span class="text-body-xs text-surface-500 line-through text-center">{{
          product().amount | currencyFormat
        }}</span>
        <span class="text-body-700 text-emerald-700 ml-1">{{ product().total | currencyFormat }}</span>
      </span>
    } @else {
      <span class="text-body-700 text-emerald-700 leading-none">{{ product().total | currencyFormat }}</span>
    }
  </div>
</div>

@if (!isReadonly() && !isKitLinkedProduct() && (canCancel() || canDelete())) {
  <div class="hidden lg:block w-px h-8 self-center bg-surface-200 shrink-0 mx-5"></div>
  <span
    class="hidden lg:inline-flex cursor-pointer text-surface-500 items-center justify-center shrink-0"
    (click)="$event.stopPropagation(); openActionMenu($event)"
  >
    <i class="pi pi-ellipsis-v text-body-sm leading-5 md:leading-none"></i>
  </span>
}

<div
  class="flex lg:hidden items-center justify-between gap-3 w-full basis-full shrink-0 mt-3"
  (click)="$event.stopPropagation()"
>
  @if (hasDiscount()) {
    <div class="grid grid-cols-2 gap-x-3 gap-y-0.5">
      <span class="text-body-2xs text-surface-500 line-through">{{ product().unitPrice | currencyFormat }} ea</span>
      <span class="text-body-2xs text-surface-500 line-through">{{ product().amount | currencyFormat }}</span>
      <span class="text-body-xs text-surface-700">{{ discountedUnitPrice() | currencyFormat }} ea</span>
      <span class="text-body-xs-700 text-emerald-700">{{ product().total | currencyFormat }}</span>
    </div>
  } @else {
    <div class="flex items-center gap-3">
      <span class="text-body-xs text-surface-700">{{ product().unitPrice | currencyFormat }} ea</span>
      <span class="text-body-xs-700 text-emerald-700">{{ product().total | currencyFormat }}</span>
    </div>
  }
  @if (canChangeQuantity()) {
    <div
      class="flex items-center justify-between h-5 lg:h-8 gap-1 px-1 rounded-full border border-outline-green shrink-0"
    >
      <p-button
        icon="pi pi-minus"
        [text]="true"
        [rounded]="true"
        size="small"
        severity="secondary"
        styleClass="!text-outline-green !w-4 !h-4 lg:!w-6 lg:!h-6"
        [disabled]="!canDecreaseQuantity()"
        [attr.aria-label]="'Decrease quantity'"
        (onClick)="$event.stopPropagation(); decreaseQuantity()"
      />
      <span class="text-body-xs lg:text-body text-surface-700 leading-none min-w-4 text-center">{{
        product().quantity
      }}</span>
      <p-button
        icon="pi pi-plus"
        [text]="true"
        [rounded]="true"
        size="small"
        severity="secondary"
        styleClass="!text-outline-green !w-4 !h-4 lg:!w-6 lg:!h-6"
        [disabled]="!canIncreaseQuantity()"
        [attr.aria-label]="'Increase quantity'"
        (onClick)="$event.stopPropagation(); increaseQuantity()"
      />
    </div>
  } @else {
    <span class="text-body-xs lg:text-body text-surface-700 leading-none shrink-0">{{ product().quantity }}</span>
  }
</div>

@if (!isReadonly()) {
  <p-menu #actionMenu [model]="actionMenuItems()" [popup]="true" appendTo="body" />
  <p-confirmdialog appendTo="body" />
}
